import React, { useEffect } from "react";
import PicturesUploadRequired from "./PicturesUploadRequired";
import { useUploadPicturesFollowUp } from "./hooks/UploadPictures";
import { useDispatch } from "react-redux";
import { addGtmPageView as pageview } from "redux/actions/gtmActions";
import { CardTitle } from "components/Cards/CardsStyled";
import { useTranslate } from "hooks/translation-hooks";

export const UploadPictures = () => {
  const {
    sendPictures,
    doneWithPictures,
    numberOfPictures,
    pictures
  } = useUploadPicturesFollowUp();
  const t = useTranslate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(pageview("PICTURES_UPLOAD_REQUIRED"));
  }, [dispatch]);

  return (
    <>
      <CardTitle>{t("upload_photos_card-title")}</CardTitle>
      <PicturesUploadRequired
        sendPictures={sendPictures}
        doneWithPictures={doneWithPictures}
        numberOfPictures={numberOfPictures}
        pictures={pictures}
      />
    </>
  );
};

export default UploadPictures;
